module.exports = __webpack_public_path__ + "static/media/cc.dd392e29.svg";